export const getProgressStatus = (progress = 0) => {
  if (progress === 0) return "Pending";
  if (progress < 50) return "At Risk";
  if (progress < 100) return "On Track";
  return "Completed";
};

export const filterBySearchAndStatus = ({
  data,
  searchTerm,
  statusFilter,
  searchKeys = [],
}) => {
  return data
    .filter((item) => {
      if (!statusFilter) return true;
      return getProgressStatus(item.progressLevel) === statusFilter;
    })
    .filter((item) => {
      if (!searchTerm) return true;
      const term = searchTerm.toLowerCase();
      return searchKeys.some(
        (key) => item[key] && item[key].toLowerCase().includes(term)
      );
    });
};
